import { getUrlDefaults } from '~/src/Lib/Nav'

const urls = getUrlDefaults('tasks')

export default urls
